module.exports = __webpack_public_path__ + "static/media/2. In progress.7fa506b6.svg";